'use client';
import React, { useState, useEffect } from 'react';
import { trackEvent } from '@/lib/analytics';
import { clientService } from '@/services/clientService';

export default function CTASection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    preferredDate: '',
    notes: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [gaSessionId, setGaSessionId] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('get', 'G-XXXXXXXXXX', 'session_id', (sessionId: string) => {
        setGaSessionId(sessionId);
      });
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      let client = await clientService.getClientByEmail(formData.email);

      if (client.error || !client.data) {
        const newClient = await clientService.createClient({
          email: formData.email,
          fullName: formData.name,
          phone: formData.phone,
          source: 'organic'
        });

        if (newClient.error) {
          throw new Error('Nepodařilo se uložit údaje');
        }

        client.data = newClient.data;
      }

      if (!client.data) {
        throw new Error('Nepodařilo se uložit údaje');
      }

      const booking = await clientService.createConsultationBooking({
        clientId: client.data.id,
        preferredDate: formData.preferredDate,
        meetingType: 'partnership',
        notes: formData.notes,
        gaSessionId: gaSessionId || undefined
      });

      if (booking.error) {
        throw new Error('Nepodařilo se odeslat žádost o konzultaci');
      }

      trackEvent({
        action: 'booking_request',
        category: 'conversion',
        label: 'Partnership Consultation Requested'
      });

      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', preferredDate: '', notes: '' });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return;












































































































}